import React, {Fragment} from 'react';
import {Form, Input} from 'semantic-ui-react';

const BlacklistDomainForm = ({
  blacklistDomain,
  handleTextChanged,
  isReadOnly,
  isBeingEdited,
}) => {
  return (
    <Fragment>
      <Form.Field
        id="form-create-domainName"
        name="domainName"
        disabled={isReadOnly}
        value={blacklistDomain.domainName}
        onChange={handleTextChanged}
        control={Input}
        label="Domain Name"
      />
    </Fragment>
  );
};

export default BlacklistDomainForm;
